const {
  WEB_VITALS,
  RESOURCE_TIMING,
  CLIENT_COOKIES,
  PAGE_RENDER,
  A11Y,
  AVAILABILITY,
  CDN_HEALTH,
  TRAFFIC_HEALTH,
  SESSION_REPLAY,
} = require('../../constants/initiatives');
const webVitals = require('./web-vitals');
const resourceTiming = require('./resource-timing');
const clientCookies = require('./client-cookies');
const pageRender = require('./page-render');
const a11y = require('./a11y');
const availability = require('./availability');
const cdnHealth = require('./cdn-health');
const trafficHealth = require('./traffic-health');
const sessionReplay = require('./session-replay');

module.exports = {
  [WEB_VITALS]: webVitals,
  [RESOURCE_TIMING]: resourceTiming,
  [CLIENT_COOKIES]: clientCookies,
  [PAGE_RENDER]: pageRender,
  [A11Y]: a11y,
  [AVAILABILITY]: availability,
  [CDN_HEALTH]: cdnHealth,
  [TRAFFIC_HEALTH]: trafficHealth,
  [SESSION_REPLAY]: sessionReplay,
};
